var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectionFilled = function SvgCollectionFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.556 11.24a2.4 2.4 0 0 1-2.431-2.43V4.556a2.4 2.4 0 0 1 2.43-2.431H8.81a2.4 2.4 0 0 1 2.43 2.43V8.81a2.4 2.4 0 0 1-2.43 2.43H4.556Zm0 10.635a2.4 2.4 0 0 1-2.431-2.43V15.19a2.4 2.4 0 0 1 2.43-2.43H8.81a2.4 2.4 0 0 1 2.43 2.43v4.254a2.4 2.4 0 0 1-2.43 2.431H4.556Zm12.761-19.75a4.571 4.571 0 0 0-4.557 4.558 4.571 4.571 0 0 0 4.557 4.557 4.571 4.571 0 0 0 4.558-4.557 4.571 4.571 0 0 0-4.558-4.558ZM12.76 15.19a2.4 2.4 0 0 1 2.43-2.43h4.254a2.4 2.4 0 0 1 2.431 2.43v4.254a2.4 2.4 0 0 1-2.43 2.431H15.19a2.4 2.4 0 0 1-2.43-2.43V15.19Z",
    fill: "#000"
  })));
};
export default SvgCollectionFilled;